module.exports = __webpack_public_path__ + "static/media/colicoli2.62cf0a16.webp";